// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nWQLn","questions":"styles_questions__2wAyR","footer":"styles_footer__35YSl"};